import {
  flatten2DArray,
  getNextStoryImages,
  reorderAndAddMatchPercent,
  sortedDishArray,
} from "../../utils/helper";

const EXCLUDED_DISH_NAMES = ["veg alfredo pasta", "paneer lababdar"];
const MAX_EXPLORE_DISHES = 25;

const getFoodChoiceFilter = (foodChoiceState) => {
  switch (foodChoiceState) {
    case "VEG":
      return ["veg"];
    case "NONVEG":
      return ["non veg", "veg", "egg"];
    default:
      return ["non veg", "veg", "egg"];
  }
};

export const getChefExperiencesExploreList = (chefExperiences) => {
  if (!chefExperiences) return [];
  const allExperiences = [].concat.apply(
    [],
    Object.values(chefExperiences)
  );
  return allExperiences.filter((exp) => exp.mediaType !== "Carousel" && !["Page","User"].includes(exp.creatorType)).map((exp) => ({
    _id: exp._id,
    name: exp.name || exp.creatorName || "Experience",
    img: exp.chefImg || "",
    type: exp.type || "veg",
    description: exp.description || "",
    ingredientCost: 0,
    packagingCost: 0,
    fuelCost: 0,
    deliveryCost: 0,
    margin: 0,
    price: exp.price || 0,
    chefId: exp.chefId,
    chefName: exp.chefName || "",
    chefImg: exp.chefImg || "",
    isActive: exp.isActive,
    isDeleted: exp.isDeleted,
    unavailable: exp.unavailable,
    createdAt: exp.createdAt,
    updatedAt: exp.updatedAt,
    categoryHeader: exp.name || "Experiences",
    dishSpecialType: "experience",
    categoryImg: exp.chefImg || "",
    categoryId: exp.chefId,
    stories: exp.stories,
    storyImages: [
      exp.chefImg || "",
      exp.chefImg || "",
      exp.chefImg || "",
      exp.chefImg || "",
      exp.chefImg || "",
    ],
  }));
};

export const getSortedExploreDishes = (categories, foodChoiceState, dishRecommendation) => {
  const merged = [].concat.apply([], Object.values(categories));

  const categoriesWithClass = merged.filter((category) => {
    if (category.img)
      return {
        ...category,
        ringClass: "ring-" + category.color,
      };
  });

  const exploreDishes = flatten2DArray(categoriesWithClass).filter(
    (a) => a.stories.length === 4
  );

  const selectedFoodChoice = getFoodChoiceFilter(foodChoiceState);

  const allExploreDishes =
    exploreDishes.filter((a) => selectedFoodChoice.includes(a.type)) || [];

  const filteredExploreDishes = sortedDishArray(allExploreDishes)
    .filter(
      (item) =>
        !EXCLUDED_DISH_NAMES.includes(item?.name?.toLowerCase()?.trim())
    )
    .slice(0, MAX_EXPLORE_DISHES);

  return reorderAndAddMatchPercent(
    [...getNextStoryImages([...filteredExploreDishes])],
    dishRecommendation
  );
};
